export var DEFAULT_FILE_SIZE = 20 * 1024 * 1024;
